import 'antd/dist/antd.css'
import React, { Component } from 'react'
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next'
import i18nextConfig from './config/i18next'
import moment from 'moment'
import 'moment/locale/es'
import {BrowserRouter as Router, Route, RouterProvider, Routes} from 'react-router-dom'
import {LayoutPrivate, LayoutPublic} from './layouts'
import {Loading, ModalChangePassword} from './layouts/Private/components'
import {
    AdminPage,
    BatchPage,
    CdiInvestigacionPage_v2,
    HomePage,
    MfaPage,
    InterestConflictsPage,
    InterestConFlictsPage_v2,
    LoginPage,
    GoogleLoginPage,
    AuthLoginPage,
    MonitoringPage,
    NewRegisterPage,
    NotAuthorizedPage,
    NotFoundPage,
    OnBoardingPage,
    ProfilePage,
    Query2Page,
    QueryPage,
    QuiebrasPage,
    ReportHistoryPage,
    ResetPasswordPage,
    StakeholderPage,
    StakeholderPortalPage,
    QueryRiskPage,
    InsidePage
} from './pages'
import {
    GenFormDirPage,
    GenFormTrabPage,
    GenFormSocPage,
    GenFormProvPage,
    GenFormFpPage,
    GenFormGiftPage,
    GenFormPepPage,
    GenFormTravelPage,
    GenFormValuesPage
} from './pages/InterestConflicts/forms/GenericForms'
import {
    FormDirPage as FormDirPageSmu,
    FormProvPage as FormProvPageSmu,
    FormTrabPage as FormTrabPageSmu
} from './pages/InterestConflicts/forms/smu'
import {
    FormProvPage as FormProvPagePF,
    FormTrabPage as FormTrabPagePF
} from './pages/InterestConflicts/forms/pfalimentos'
import {
    FormDirPage as FormDirPageNC,
    FormProvPage as FormProvPageNC,
    FormTrabPage as FormTrabPageNC
} from './pages/InterestConflicts/forms/nuevocapital'
import {
    FormDirPage as FormDirPageCLA,
    FormProvPage as FormProvPageCLA,
    FormTrabPage as FormTrabPageCLA,
    FormTravelPage as FormTravelPageCLA,
    FormGiftPage as FormGiftPageCLA,
    FormFPPage as FormFPPageCLA,
    FormSocPage as FormSocPageCLA
} from './pages/InterestConflicts/forms/cajalosandes'
import {FormPatrPage as FormPatrPageBtg, FormTrabPage as FormTrabPageBtg} from './pages/InterestConflicts/forms/btg'
import {FormTrabPage as FormTrabPageSC} from './pages/InterestConflicts/forms/santanderConsumer'
import {FormTrabPage as FormTrabPageFam} from './pages/InterestConflicts/forms/famae'

import { FormTrabPage as FormTrabAguasAndinas,
         FormProvPage as FormProvAguasAndinas,
         FormDirPage as FormDirAguasAndinas,
         FormTravelPage as FormTravelAguasAndinas,
         FormSocPage as FormSocAguasAndinas,
         FormGiftPage as FormGiftAguasAndinas,
         FormFPPage as FormFPAguasAndinas 
        }  from './pages/InterestConflicts/forms/aguasandinasform'
import { FormTrabPage as FormTrabSonda,
            FormProvPage as FormProvSonda,
            FormDirPage as FormDirSonda,
            FormTravelPage as FormTravelSonda,
            FormGiftPage as FormGiftSonda 
           }  from './pages/InterestConflicts/forms/sonda'
import {
    FormDirPage as FormDirPageREA,
    FormProvPage as FormProvPageREA,
    FormTrabPage as FormTrabPageREA,
    FormTravelPage as FormTravelPageREA,
    FormGiftPage as FormGiftPageREA,
    FormFPPage as FormFPPageREA,
    FormSocPage as FormSocPageREA
} from './pages/InterestConflicts/forms/reale'
import {FormKycPage} from './pages/OnBoarding/forms/FormKyc'
import {FormKycPageAraucoMalls} from './pages/OnBoarding/forms/arauco-malls'
import {FormKycCliPage as FormKycCliPageParauco, FormKycProvPage as FormKycProvPageParauco} from './pages/OnBoarding/forms/parauco'
import { FormKycCliPage as FormKycCliPageParaucoPe, FormKycProvPage as FormKycProvPageParaucoPe} from './pages/OnBoarding/forms/Peru/parauco'

import { Form } from './pages/FormManager'
import { ModalRecord } from './pages/Register/components'

import {SessionStorageService, LocalStorageService, ReportService} from './services'
import {authTokenRenewerHelper, authTokenValidatorHelper, sessionStorageCleanerHelper, authTokenSessionStorageSaverHelper, getReportFileNameHelper} from './helpers'
import {
    animateLogoutPromise,
    changePasswordPromise,
    deleteReportPromise,
    generateReportPromise,
    getCurrentUserPromise,
    getReportByUserPromise,
    getReportPromise,
    logoutPromise,
    removeLoginAnimationsPromise,
    getAuthEmailTokenPromise,
    getDataSourcesCatalogoPromise, getDataSourcesFormPromise, getDataSourcesSystemPromise
} from './promises'
import { getDomainPromise, getOauthConfigPromise } from './pages/Stakeholder/promises'
import { decodeAuthToken } from './helpers/decodeAuthToken'

import {Icon, message, Modal, Tooltip} from 'antd'
import {globalContext} from "./contexts";
import { GenFormColabPage } from './pages/InterestConflicts/forms/GenericForms'
import { FormTrabPage as FormTrabZofri, FormFpZofri} from './pages/InterestConflicts/forms/zofri'
import {t} from "i18next";

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';

const datadogEnabled = Boolean(process.env.REACT_APP_DATADOG_ENV)

if (datadogEnabled) {
    datadogRum.init({
        applicationId: '21bf2896-5b43-455a-9c9e-fcb24745c5fd',
        clientToken: 'pub1b47829bab6273610d2c99f1c304aaaf',
        site: 'datadoghq.com',
        service: 'AMLupdate',
        env: process.env.REACT_APP_DATADOG_ENV,				// e.g. 'prod', 'staging-1', 'dev'
        version: '1.0',	// e.g. '1.0.0'
        sessionSampleRate: 100,			// capture 100% of sessions
        sessionReplaySampleRate: 50,	// capture 20% of sessions with replay
        trackResources: true,			// Enable Resource tracking
        trackUserInteractions: true,	// Enable Action tracking
        trackLongTasks: true,			// Enable Long Tasks tracking

        // ----- Recommended Options -----
        // allowedTracingUrls: '<BACKEND_URL>',		// Enable distributed tracing
        // defaultPrivacyLevel: 'mask-user-input',	// 'mask-user-input' | 'allow' | 'mask'
        plugins: [reactPlugin({ router: true })],
        beforeSend: (event) => {
            if (event.type === 'action' && event.action.target?.name?.includes('FONT')) {
                return false; // Ignora la acción y evita el choque en el DOM
            }
            return true;
        },
    })
}

class App extends Component {
    state = {
        userParams: {},
        currentUser: {},
        isActivated: true,
        changePasswordForced: false,
        isLoading: true,
        isLoggedIn: false,
        //loginOauthConfig: {provider:'oauth2', authority:'https://login.microsoftonline.com/147b2161-64ba-4232-9eb3-f1045ef9d339/v2.0', clientId:'0451d04d-424d-4185-9b82-e8e454b7a087'},
        isModalChangePasswordVisible: false,
        isModalWantToChangePwdVisible: false,
        reportId: null,
        intervalReportId: null,
        finishReportCB: null,
        mfaAuthenticated: false,
        //client: {id: '0c1458a7-2256-4711-88dc-93024c8c2911', name: 'test'},
        externalAuth: null,
        authResponse: null
    }

    async loadFormDatasource(formId, callback) {
        let { datasources } = this.state
        if(!datasources) {
            const ds = await getDataSourcesCatalogoPromise()
            const sys = await getDataSourcesSystemPromise(formId)
            datasources = { CAT: { ...ds, ...sys} }
        }
        
        getDataSourcesFormPromise(formId).then(ds => {
            if(Object.keys(ds).length > 0) {
                datasources.FORM = ds 
            }
            this.setState({ datasources })
            if(callback) callback(datasources)
        })
    }

    async initUser(validatePwd) {
        const language = i18nextConfig.language

        const userData = await this.getCurrentUser()
        const currentUser = userData.user
        const userType = SessionStorageService.read("userType")

        if (!(userType && (userType === currentUser.type))) {
            message.error("Error, acceso vulnerado");
        } else {
            const isActivated = currentUser.feActivacion !== null || !validatePwd
            const isPasswordBlocked= (LocalStorageService.read("isPasswordBlocked") === "true")

            if ((!isActivated) || isPasswordBlocked) {
                const messageToModal= (!isActivated) ?  "por cambio de contraseña"  : "por contraseña caducada";
                if(!isActivated){
                    this.setState({changePasswordForced: true})
                }else {
                    this.setState({changePwdMessage: messageToModal})
                }
                this.handleOpenModalChangePassword()
            } else {
                this.setState({
                    userParams: userData,
                    mfaAuthenticated: currentUser.authenticatedWith2FA
                })
                const isPwdNextToExpired = currentUser.pwdNextToExpired && validatePwd
                if( isPwdNextToExpired) {
                    this.handleOpenModalWantToChangePwdModal()
                }
                //if(!currentUser.hasMfaKey && !document.location.pathname.startsWith('/mfa') &&
                //    (userData?.system?.mfa === 'requerido'
                //    || (userData?.system?.mfa === 'opcional' && currentUser.cliente?.modules?.includes('MFAOPT') && currentUser.cliente?.modules?.includes('MFAREQ')))) {
                //    document.location.href = '/mfa'
                //}else {
                    this.setState({
                        currentUser,
                        isLoggedIn: true
                    })
                    new authTokenRenewerHelper(this.handleLogout.bind(this))
                    removeLoginAnimationsPromise()

                    if (currentUser.cliente.pais !== 'CHI') {
                        i18nextConfig.changeLanguage(language.substring(0, 2) + currentUser.cliente.pais)
                    }

                    this.loadUser()
                //}
            }
        }
    }

    async initAuth(externalAuth) {
        this.setState({externalAuth})
    }

    async componentDidMount() {
        const language = i18nextConfig.language
        moment.locale(language.substring(0, 2))

        this.handleThemeCheck()

        let verifySubdomain = false;
        let loginOauthConfig = null;
        if(process.env.REACT_APP_MAIN_DOMAIN && document?.location?.pathname && !document.location.pathname.startsWith('/forms/') && !document.location.pathname.startsWith('/portal/')) {
            const hosts = process.env.REACT_APP_MAIN_DOMAIN.split(",")
            if(!hosts.includes(document.location.hostname)) {
                const hostname = document.location.hostname.split(".")
                const subdomain = hostname[0]
                verifySubdomain = true
                const rDomain = await getDomainPromise(subdomain);
                if(rDomain?.data?.id) {
                    this.setState({client: rDomain.data})
                    const rOauth = await getOauthConfigPromise(rDomain.data.id)
                    if(rOauth?.provider) {
                        loginOauthConfig = rOauth
                    }
                    this.setState({isLoading: false})
                }else {
                    this.setState({client: {error: 404}})
                    this.setState({isLoading: false})
                }
            }
        }
        if(loginOauthConfig) this.setState({loginOauthConfig})

        const isValidAuthToken = await authTokenValidatorHelper()
        if (isValidAuthToken) {
            await this.initUser(!loginOauthConfig && !document.location.pathname.startsWith('/record/'))
        }
        if(!verifySubdomain) this.setState({isLoading: false})
    }

    handleThemeCheck() {
        const theme = LocalStorageService.read('theme')

        if (theme !== null) {
            document.body.className = theme
        } else {
            document.body.className = 'theme-metal'
        }
    }

    async handleLogin() {
        if (window.location.pathname.startsWith('/consulta/')) {
            window.history.replaceState(null, '', '/consulta')
        }
        this.initUser(true)
    }

    async handleLoginEmail(token, email) {
        const {client} = this.state

        const authToken = await getAuthEmailTokenPromise(client.id, email, token);
        if (!authToken.error) {
            if (authToken && authToken.token) {
                await authTokenSessionStorageSaverHelper(authToken)
        
                const decodedToken = decodeAuthToken(authToken.token);
                SessionStorageService.create("userType",decodedToken.type);
                LocalStorageService.create("isPasswordBlocked",decodedToken.isPasswordBlocked);
        
                await this.initUser(false)
            }
        }
        authToken.email = email
        this.setState({authResponse: authToken})
    }

    loadUser() {
        getReportByUserPromise().then(report => {
            if (report) {
                this.setState({reportId: report.id})
                const intervalId = setInterval(() => {
                    this.checkStatusReport()
                }, 2000);
                this.setState({intervalReportId: intervalId})
            }
        }).catch(() => {})
    }

    async checkStatusReport() {
        const report = await getReportPromise(this.state.reportId)
        if (report) {
            if (report.status === 'FINISHED' || report.status === 'DOWNLOADED') {
                if (report.status === 'FINISHED') {
                    const fileName = getReportFileNameHelper(report.type, report.extension)
                    clearInterval(this.state.intervalReportId)
                    const {finishReportCB, reportId} = this.state
                    if (finishReportCB) finishReportCB(report.type)
                    this.setState({intervalReportId: null, reportId: null, finishReportCB: null})

                    message.loading({content: t("messages.aml.downloadingReport"), duration: 0, key: 'msg-report'})
                    await ReportService.read('/getFileReporte', {id: reportId}, null, fileName, {
                        onDownloadProgress: (progressEvent) => {
                            const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            if (progressEvent.total > 0) {
                                message.loading({
                                    content: t("messages.aml.downloadingReport") + percentCompleted + '%',
                                    duration: 0,
                                    key: 'msg-report'
                                })
                            }
                        }
                    })
                    message.destroy()
                }
            } else {
                let content = (<>
                    {t('messages.aml.generatingReport')} {report.processed === 0 ? 0 : parseInt(report.processed * 100 / report.lines)}%
                    &nbsp;&nbsp;
                    <Tooltip title={t('messages.aml.cancelReport')}><Icon type="close"
                                                            style={{cursor: 'pointer', color: 'rgba(240,0,0,.7)'}}
                                                            onClick={() => {
                                                                deleteReportPromise(report.id)
                                                            }}/></Tooltip>
                </>)
                message.loading({content, duration: 0, key: 'msg-report'})
            }
        } else {
            clearInterval(this.state.intervalReportId)
            message.destroy()

            const {finishReportCB} = this.state
            if (finishReportCB) finishReportCB()

            this.setState({intervalReportId: null, reportId: null, finishReportCB: null})
        }
    }

    async handleLogout() {
        logoutPromise().then(r => {
            console.log("Logout exitoso");
        })
        .catch(e => {
            console.log("Error de Logout");
        })
        const {externalAuth, loginOauthConfig} = this.state
        if(externalAuth && externalAuth.logout && loginOauthConfig) {
            externalAuth.logout()
        }

        await sessionStorageCleanerHelper()
        animateLogoutPromise()

        await this.setState({
            currentUser: {},
            isActivated: true,
            isLoading: false,
            isLoggedIn: false
        })
    }

    async getCurrentUser() {
        const currentUser = await getCurrentUserPromise()
        this.setState({isLoading: false})
        return currentUser
    }

    async handleOpenModalChangePassword() {
        this.setState({isModalChangePasswordVisible: true})
    }

    async handleCloseModalChangePassword() {
        this.setState({isModalChangePasswordVisible: false})
    }

    async handleOpenModalWantToChangePwdModal() {
        this.setState({isModalWantToChangePwdVisible: true})
    }

    async handleCloseModalWantToChangePwdModal() {
        this.setState({isModalWantToChangePwdVisible: false})
    }

    async handleSaveChangePassword(passwordCurrent, passwordNew, passwordNewConfirm) {
        await changePasswordPromise(passwordCurrent, passwordNew, passwordNewConfirm)
        this.setState({isModalChangePasswordVisible: false})
    }

    async generateReport(type, filters, cb) {
        const {reportId} = this.state
        if (reportId === null) {
            const id = await generateReportPromise(type, filters)
            this.setState({reportId: id, finishReportCB: cb})
            const intervalId = setInterval(() => {
                this.checkStatusReport()
            }, 2000);
            this.setState({intervalReportId: intervalId})
            return true
        } else {
            message.warn({content: 'Ya existe un reporte activo', duration: 3})
            return false
        }
    }

    validaMfaAuthenticated() {
        return this.state.mfaAuthenticated
    }

    validaMfaRequired() {
        const {currentUser, userParams} = this.state
        if(userParams?.system?.mfa === 'requerido' || (userParams?.system?.mfa === 'opcional' && currentUser.cliente.modules?.includes('MFAOPT'))) {
            if(!currentUser.hasMfaKey) {
                if(userParams?.system?.mfa === 'requerido') {
                    return true
                }else if(userParams?.system?.mfa === 'opcional' && currentUser.cliente.modules?.includes('MFAOPT') && currentUser.cliente.modules?.includes('MFAREQ')) {
                    return true
                }
            }else if(!currentUser.authenticatedWith2FA) {
                return true
            }
        }
        return false
    }

    renderComponent(CurrentPage, protectedContent = null) {
        const {isLoggedIn, loginOauthConfig, currentUser, userParams, client, authResponse} = this.state
        let CurrenComponent
        if (currentUser.cliente ) {
            const modules = currentUser.modules || []
            if (!currentUser.cliente.modules.includes('AML2')) {
                CurrentPage = NotAuthorizedPage
            } else {
                if(protectedContent !== 'mfa' && this.validaMfaRequired()) {
                    CurrentPage = MfaPage
                }else {
                    switch (protectedContent) {
                        case 'mfa':
                            CurrentPage = ((userParams?.system?.mfa === 'opcional' && currentUser.cliente.modules?.includes('MFAOPT')) || userParams?.system?.mfa === 'requerido' ) ? CurrentPage : NotAuthorizedPage
                            break
                        case 'query':
                            CurrentPage = (currentUser.cliente.planHist !== null && currentUser.cliente.modules.includes('CONSULTA') && modules.includes('CONSULTA')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'query2':
                            CurrentPage = (currentUser.cliente.planHist !== null && currentUser.cliente.modules.includes('CONSULTA2')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'queryrisk':
                            CurrentPage = (currentUser.cliente.planHist !== null && currentUser.cliente.modules.includes('QUERY-RISK') && modules.includes('QUERY-RISK')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'monitoring':
                            CurrentPage = (currentUser.cliente.modules.includes('MONITOR') && modules.includes('MONITOR')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'batch':
                            CurrentPage = (currentUser.cliente.planBatch !== null && currentUser.cliente.planBatch.tipo === 'ABIERTO' && currentUser.cliente.modules.includes('BATCH') && modules.includes('BATCH')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'register':
                            CurrentPage = (currentUser.cliente.modules.includes('REGISTRO') && modules.includes('REGISTRO')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'conflict':
                            CurrentPage = (currentUser.cliente.modules.includes('CDI-MATCH') || currentUser.cliente.modules.includes('CDI-FORM')) && (modules.includes('CDI-MATCH') || modules.includes('CDI-FORM')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'bankruptcy':
                            CurrentPage = (currentUser.cliente.modules.includes('QUIEBRA') && modules.includes('QUIEBRA')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'onboarding':
                            CurrentPage = (currentUser.cliente.modules.includes('ONBOARDING') && modules.includes('ONBOARDING')) ? CurrentPage : NotAuthorizedPage
                            break

                        case 'admin':
                            CurrentPage = (currentUser.type === 'SADMIN' || currentUser.type === 'ADMIN' || currentUser.type === 'AUDIT') ? CurrentPage : NotAuthorizedPage
                            break
                        case 'contenidos':
                            CurrentPage = ((currentUser.type === 'USUARIO' || currentUser.type === 'SADMIN' || currentUser.type === 'ADMIN' || currentUser.type === 'AUDIT')
                                        && ((currentUser.cliente.modules.includes('NEG') && modules.includes('LOADNEG'))
                                            || (currentUser.cliente.modules.includes('TRANS_FILES') && modules.includes('USER_TRANS_FILE'))
                                            || (currentUser.cliente.modules.includes('FORM-MANAGER') && modules.includes('FORM-MANAGER'))
                                            || (currentUser.cliente.modules.includes('AUTH-SEARCH') && modules.includes('OFCTO'))
                                        )
                                )
                            ? CurrentPage : NotAuthorizedPage
                            break
                        case 'inside-compliance':
                            CurrentPage = (currentUser.cliente.modules.includes('INSIDE') && modules.includes('INSIDE'))  ? CurrentPage : NotAuthorizedPage
                            break

                        default:
                    }
                }
            }
        }else if(protectedContent === 'home') {
            if(process.env.REACT_APP_PORTAL_DOMAIN) {
                const hosts = process.env.REACT_APP_PORTAL_DOMAIN.split(",")
                for(let host of hosts) {
                    const data = host.split("=")
                    if(data[0] === document.location.hostname) {
                        CurrenComponent = <StakeholderPage domain={data[1]}/>
                        break
                    }
                }
            }
        }
        if(!CurrenComponent) {
            if(loginOauthConfig?.provider === 'oauth2') {
                CurrenComponent = <AuthLoginPage client={client} initAuth={this.initAuth.bind(this)} config={loginOauthConfig} authResponse={authResponse} successHandler={this.handleLoginEmail.bind(this)}>
                            { isLoggedIn && <CurrentPage currentUser={currentUser}  protectedContent={protectedContent}/> }
                        </AuthLoginPage>
            }else if(loginOauthConfig?.provider === 'google-oauth2') {
                CurrenComponent = <GoogleLoginPage client={client} initAuth={this.initAuth.bind(this)} config={loginOauthConfig} authResponse={authResponse} successHandler={this.handleLoginEmail.bind(this)}>
                            { isLoggedIn && <CurrentPage currentUser={currentUser}  protectedContent={protectedContent}/> }
                        </GoogleLoginPage>
            }else if(isLoggedIn) {
                CurrenComponent = <CurrentPage currentUser={currentUser} protectedContent={protectedContent} />
            }else if(client?.error === 404) {
                CurrenComponent = <NotFoundPage />
            }else if(client?.error === 403) {
                CurrenComponent = <NotAuthorizedPage />
            }else {
                CurrenComponent = <LoginPage successHandler={this.handleLogin.bind(this)} client={client} />
            }
        }
        return CurrenComponent
    }

    render() {
        const {currentUser, userParams, isLoading, isLoggedIn, isModalChangePasswordVisible, isModalWantToChangePwdVisible, changePasswordForced, datasources} = this.state
        const Layout = isLoggedIn ? LayoutPrivate : LayoutPublic

        if (isLoading) {
            return <Loading/>
        } else {
            return (
                <I18nextProvider i18n={i18nextConfig}>
                    <globalContext.Provider value={{currentUser, userParams, validaMfaAuthenticated: this.validaMfaAuthenticated.bind(this), generateReport: this.generateReport.bind(this), datasources, loadFormDatasource: this.loadFormDatasource.bind(this)}}>
                        <Routes>
                                {/* Rutas del stakeholder */}
                                <Route path="/portal/cl" element={ <StakeholderPortalPage countryCode="CHI"/>} />
                                <Route path="/portal/co" element={ <StakeholderPortalPage countryCode="COL"/>} />
                                <Route path="/portal/cr" element={ <StakeholderPortalPage countryCode="CR"/>} />
                                <Route path="/portal/pe" element={ <StakeholderPortalPage countryCode="PER"/>} />
                                <Route path="/portal/:domain" element={ <StakeholderPage/>} />
                                
                                <Route path="/record/:clientId/:id" element={ <ModalRecord/>} />
                                <Route path="/resetpw" element={ <LayoutPublic><ResetPasswordPage/></LayoutPublic>} />

                                {/* Rutas de AML v2 */}
                                <Route element={<Layout currentUser={currentUser} logoutHandler={this.handleLogout.bind(this)} />}>
                                    <Route path="/" element={ this.renderComponent(HomePage, 'home') } />
                                    <Route path="/mfa" element={ this.renderComponent(MfaPage, 'mfa') } />
                                    <Route path="/consulta" element={ this.renderComponent(QueryPage, 'query') } />
                                    <Route path="/consulta2" element={ this.renderComponent(Query2Page, 'query2') } />
                                    <Route path="/query-risk" element={ this.renderComponent(QueryRiskPage, 'queryrisk') } />
                                    <Route path="/monitoreo/eventos" element={ this.renderComponent(MonitoringPage, 'monitoring') } />
                                    <Route path="/monitoreo/:params?" element={ this.renderComponent(MonitoringPage, 'monitoring') } />
                                    <Route path="/consulta/:text" element={ this.renderComponent(QueryPage, 'query') } />
                                    <Route path="/masivos" element={ this.renderComponent(BatchPage, 'batch') } />
                                    <Route path="/perfil/:id" element={ this.renderComponent(ProfilePage, 'query') } />
                                    <Route path="/administracion" element={ this.renderComponent(AdminPage, 'admin') } />
                                    <Route path="/contenidos" element={ this.renderComponent(AdminPage, 'contenidos') } />
                                    <Route path="/registro/:params?" element={ this.renderComponent(NewRegisterPage, 'register') } />
                                    <Route path="/quiebras" element={ this.renderComponent(QuiebrasPage, 'bankruptcy') } />
                                    <Route path="/conflictos-de-interes" element={ this.renderComponent(InterestConflictsPage, 'conflict') } />
                                    <Route path="/onboarding/" element={ this.renderComponent(OnBoardingPage, 'onboarding') } />
                                    <Route path="/declaraciones/:params?" element={ this.renderComponent(InterestConFlictsPage_v2, 'cdi') } />
                                    <Route path="/cdi-relaciones/" element={ this.renderComponent(CdiInvestigacionPage_v2, "cdi-relaciones")} />
                                    <Route path="/cdi-investigacion/" element={ this.renderComponent(CdiInvestigacionPage_v2, "cdi-investigacion")} />
                                    <Route path="/inside-compliance/" element={ this.renderComponent(InsidePage, "inside-compliance")} />
                                    <Route path="/historial-de-reportes" element={ this.renderComponent(ReportHistoryPage, "historial-de-reportes")}/>
                                    <Route path="/callback-oauth2" element={ this.renderComponent(HomePage, 'callback')}/>

                                    {/* Formularios Form Manager */}
                                    <Route path="/forms/:cliente/form/:id/:view?" element={ <Form />} />

                                    {/* Formularios CDI - SMU */}
                                    <Route path="/forms/1/formTrab/:id/:view?" element={ <FormTrabPageSmu/>} />
                                    <Route path="/forms/1/formProv/:id/:view?" element={ <FormProvPageSmu/>} />
                                    <Route path="/forms/1/formDir/:id/:view?" element={ <FormDirPageSmu/>} />

                                    {/* Formularios CDI - PF Alimentos */}
                                    <Route path="/forms/pfalimentos/formTrab/:id/:view?" element={ <FormTrabPagePF/>} />
                                    <Route path="/forms/pfalimentos/formProv/:id/:view?" element={ <FormProvPagePF/>} />

                                    {/* Formularios CDI - ZOFRI */}
                                    <Route path="/forms/zofri/formTrab/:id/:view?" element={ <FormTrabZofri/>} />
                                    <Route path="/forms/zofri/formFP/:id/:view?" element={ <FormFpZofri/>} />
                                    
                                    {/* Formularios CDI - Aguas Andinas */}
                                    <Route path="/forms/aguasandinas/formTrab/:id/:view?" element={ <FormTrabAguasAndinas/>} />
                                    <Route path="/forms/aguasandinas/formProv/:id/:view?" element={ <FormProvAguasAndinas/>} />
                                    <Route path="/forms/aguasandinas/formDir/:id/:view?" element={ <FormDirAguasAndinas/>} />
                                    <Route path="/forms/aguasandinas/formTravel/:id/:view?" element={ <FormTravelAguasAndinas/>} />
                                    <Route path="/forms/aguasandinas/formSoc/:id/:view?" element={ <FormSocAguasAndinas/>} />
                                    <Route path="/forms/aguasandinas/formGift/:id/:view?" element={ <FormGiftAguasAndinas/>} />
                                    <Route path="/forms/aguasandinas/formFP/:id/:view?" element={ <FormFPAguasAndinas/>} />

                                    {/* Formularios CDI - Sonda */}
                                    <Route path="/forms/sonda/formTrab/:id/:view?" element={ <FormTrabSonda/>} />
                                    <Route path="/forms/sonda/formProv/:id/:view?" element={ <FormProvSonda/>} />
                                    <Route path="/forms/sonda/formDir/:id/:view?" element={ <FormDirSonda/>} />
                                    <Route path="/forms/sonda/formGift/:id/:view?" element={ <FormGiftSonda/>} />
                                    <Route path="/forms/sonda/formTravel/:id/:view?" element={ <FormTravelSonda/>} />

                                    {/* Formularios CDI - Caja los Andes */}
                                    <Route path="/forms/2/formTrab/:id/:view?" element={ <FormTrabPageCLA/>} />
                                    <Route path="/forms/2/formProv/:id/:view?" element={ <FormProvPageCLA/>} />
                                    <Route path="/forms/2/formDir/:id/:view?" element={ <FormDirPageCLA/>} />
                                    <Route path="/forms/2/formTravel/:id/:view?" element={ <FormTravelPageCLA/>} />
                                    <Route path="/forms/2/formFP/:id/:view?" element={ <FormFPPageCLA/>} />
                                    <Route path="/forms/2/formSoc/:id/:view?" element={ <FormSocPageCLA/>} />
                                    <Route path="/forms/2/formGift/:id/:view?" element={ <FormGiftPageCLA/>} />

                                    {/* Formularios CDI - Reale */}
                                    <Route path="/forms/reale/formTrab/:id/:view?" element={ <FormTrabPageREA/>} />
                                    <Route path="/forms/reale/formProv/:id/:view?" element={ <FormProvPageREA/>} />
                                    <Route path="/forms/reale/formDir/:id/:view?" element={ <FormDirPageREA/>} />
                                    <Route path="/forms/reale/formTravel/:id/:view?" element={ <FormTravelPageREA/>} />
                                    <Route path="/forms/reale/formFP/:id/:view?" element={ <FormFPPageREA/>} />
                                    <Route path="/forms/reale/formSoc/:id/:view?" element={ <FormSocPageREA/>} />
                                    <Route path="/forms/reale/formGift/:id/:view?" element={ <FormGiftPageREA/>} />

                                    {/* Formularios CDI - Nuevo Capital */}
                                    <Route path="/forms/nuevocapital/formTrab/:id/:view?" element={ <FormTrabPageNC/>} />
                                    <Route path="/forms/nuevocapital/formProv/:id/:view?" element={ <FormProvPageNC/>} />
                                    <Route path="/forms/nuevocapital/formDir/:id/:view?" element={ <FormDirPageNC/>} />

                                    {/* Formularios CDI - BTG */}
                                    <Route path="/forms/btgpactual/formTrab/:id/:view?" element={ <FormTrabPageBtg/>} />
                                    <Route path="/forms/btgpactual/formPatr/:id/:view?" element={ <FormPatrPageBtg/>} />

                                    {/* Formularios CDI - Santander Consumer */}
                                    <Route path="/forms/santanderconsumer/formTrab/:id/:view?" element={ <FormTrabPageSC/>} />

                                    {/* Formularios CDI - Famae */}
                                    <Route path="/forms/3/formTrab/:id/:view?" element={ <FormTrabPageFam/>} />

                                    {/* Rutas genericas CDI*/}
                                    <Route path="/forms/:cliente/formTrab/:id/:view?" element={ <GenFormTrabPage/>} />
                                    <Route path="/forms/:cliente/formProv/:id/:view?" element={ <GenFormProvPage/>} />
                                    <Route path="/forms/:cliente/formDir/:id/:view?" element={ <GenFormDirPage/>} />

                                    <Route path="/forms/:cliente/formFP/:id/:view?" element={ <GenFormFpPage/>} />
                                    <Route path="/forms/:cliente/formSoc/:id/:view?" element={ <GenFormSocPage/>} />
                                    <Route path="/forms/:cliente/formGift/:id/:view?" element={ <GenFormGiftPage/>} />
                                    <Route path="/forms/:cliente/formTravel/:id/:view?" element={ <GenFormTravelPage/>} />
                                    <Route path="/forms/:cliente/formValues/:id/:view?" element={ <GenFormValuesPage/>} />
                                    <Route path="/forms/:cliente/formPep/:id/:view?" element={ <GenFormPepPage/>} />

                                    <Route path="/forms/:cliente/formColab/:id/:view?" element={ <GenFormColabPage/>} />

                                    {/* Formularios KYC - Parauco */}
                                    <Route path="/forms/parauco/formKyc/:id/:view?" element={ <FormKycCliPageParauco/>} />
                                    <Route path="/forms/parauco/formKycCli/:id/:view?" element={ <FormKycCliPageParauco/>} />
                                    <Route path="/forms/parauco/formKycProv/:id/:view?" element={ <FormKycProvPageParauco/>} />
                                    <Route path="/forms/arauco-malls/formKyc/:id/:view?" element={ <FormKycPageAraucoMalls/>} />

                                    {/* Formularios KYC - Parauco - Peru */}
                                    <Route path="/forms/parauco-pe/formKycCli/:id/:view?" element={ <FormKycCliPageParaucoPe/>} />
                                    <Route path="/forms/parauco-pe/formKyc/:id/:view?" element={ <FormKycCliPageParaucoPe/>} />
                                    <Route path="/forms/parauco-pe/formKycProv/:id/:view?" element={ <FormKycProvPageParaucoPe/>} />
                                    
                                    {/* Formularios KYC - Genericos */}
                                    <Route path="/forms/:client/formKycProv/:id/:view?" element={ <FormKycPage/>} />
                                    <Route path="/forms/:client/formKycTrab/:id/:view?" element={ <FormKycPage/>} />
                                    <Route path="/forms/:client/formKycDir/:id/:view?" element={ <FormKycPage/>} />
                                    <Route path="/forms/:client/formKycCli/:id/:view?" element={ <FormKycPage/>} />
                                    <Route path="/forms/:client/formKyc/:id/:view?" element={ <FormKycPage/>} />
                                    {/****************************/}

                                    <Route path="*" element={<NotFoundPage />} />
                                </Route>
                        </Routes>
                        {isModalChangePasswordVisible &&
                            <ModalChangePassword
                                visible={true}
                                onOk={this.handleSaveChangePassword.bind(this)}
                                onCancel={
                                this.handleCloseModalChangePassword.bind(this)}
                                isForced = {changePasswordForced}
                                isExpiredPassword = {LocalStorageService.read("isPasswordBlocked") === "true"}
                                isPwdNextToExpired = {isModalWantToChangePwdVisible}  //!== null
                            />
                        }
                        {isModalWantToChangePwdVisible &&
                            <Modal
                                title="¡Atención!"
                                visible={true}
                                onOk= {() => {
                                    this.handleOpenModalChangePassword();
                                    this.handleCloseModalWantToChangePwdModal();
                                }}
                                onCancel={this.handleCloseModalWantToChangePwdModal.bind(this)}
                                okText="cambiar"
                                cancelText="más tarde"
                            >
                                <p>Tu contraseña expirará en {currentUser.daysToExpiredPwd} días. Para garantizar el acceso continuo a tu cuenta, recomendamos que actualices tu contraseña antes de que expire el período.</p>
                            </Modal>
                        }
                    </globalContext.Provider>
                </I18nextProvider>
            )
        }
    }
}

let app
if (datadogEnabled) {
    const router = createBrowserRouter([
        {
            path: '*',
            element: <App />,
        }
    ])
    app = <RouterProvider router={router} />
} else {
    app = <Router><App /></Router>
}
createRoot(document.getElementById('app')).render(app)
